import createApiMiddlewareReducer from '../utils/create-api-middleware-reducer'
import {
  REQUEST_SOURCE_UPGRADE,
  REQUEST_SOURCE_UPGRADE_ERROR,
  RECEIVE_SOURCE_UPGRADE
} from 'actions'

const upgradeReducer = createApiMiddlewareReducer({
  request: REQUEST_SOURCE_UPGRADE,
  failure: REQUEST_SOURCE_UPGRADE_ERROR,
  receive: RECEIVE_SOURCE_UPGRADE
})

export default (state = {}, action) => {
  const { type, payload } = action
  let key = null

  switch (type) {
    case REQUEST_SOURCE_UPGRADE:
    case REQUEST_SOURCE_UPGRADE_ERROR:
    case RECEIVE_SOURCE_UPGRADE:
      key = `${payload.workspaceSlug}-${payload.sourceSettingSlug}`
      return {
        ...state,
        [key]: upgradeReducer(state[key], action)
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/source-upgrades/upgrades.js